module.exports = __webpack_public_path__ + "img/bottomImg.5b9c39bc.png";